module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBmaWxsPSIjM0Y1MUI1IiBkPSJNNDIsMzdjMCwyLjc2Mi0yLjIzOCw1LTUsNUgxMWMtMi43NjEsMC01LTIuMjM4LTUtNVYxMWMwLTIuNzYyLDIuMjM5LTUsNS01aDI2YzIuNzYyLDAsNSwyLjIzOCw1LDVWMzd6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTM0LjM2OCwyNUgzMXYxM2gtNVYyNWgtM3YtNGgzdi0yLjQxYzAuMDAyLTMuNTA4LDEuNDU5LTUuNTksNS41OTItNS41OUgzNXY0aC0yLjI4N0MzMS4xMDQsMTcsMzEsMTcuNiwzMSwxOC43MjNWMjFoNEwzNC4zNjgsMjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/icons8-facebook-old.svg
// module id = 486
// module chunks = 3